import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { Box, Button, IconButton, Modal, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CloseModalIcon } from './product-details-modal.styles';

export const ImageContainer = styled(Box)({
  marginLeft: '4px',
  width: '160px',
  height: '160px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative'
});

export const ProductImage = styled('img')({
  maxWidth: '160px',
  maxHeight: '160px',
  display: 'block',
  margin: 'auto'
});

export const EnlargeImageButton = styled(IconButton)({
  color: 'rgba(0, 0, 0, 0.5)',
  background: 'white',
  borderRadius: '50%',
  position: 'absolute',
  border: '1px solid rgba(0, 0, 0, 0.5)',
  '&:hover': {
    background: 'white'
  }
});

export { ZoomInIcon };

export const StyledModal = styled(Modal)({
  width: '608px',
  height: '683px',
  margin: 'auto',
  background: 'white'
});

export const BackdropStyles = {
  style: {
    background: 'transparent'
  }
};

export const ModalContent = styled(Box)({
  height: '100%',
  width: '100%',
  outline: 'none',
  boxShadow:
    '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
  borderRadius: '4px'
});

export const CloseModalButton = styled(IconButton)({
  marginTop: '10px',
  marginRight: '10px',
  '&:hover': {
    background: 'white'
  },
  alignSelf: 'flex-end'
});

export { CloseModalIcon };

export const SectionColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  justifyContent: 'flex-start'
});

export const EnlargedImageContainer = styled(Box)({
  width: '520px',
  height: '430px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const EnlargedImage = styled('img')({
  maxWidth: '520px',
  maxHeight: '430px'
});

export const ImageUrlTextbox = styled(TextField)({
  height: '58px',
  width: '520px',
  boxSizing: 'border-box',
  borderColor: 'rgba(0, 0, 0, 0.23)',
  fontFamily: 'Open Sans',
  color: '#212121',
  marginTop: '30px',
  marginBottom: '34px',
  padding: 0,
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    fontSize: '14px',
    letterSpacing: '0.15px',
    padding: '8px',
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)'
    },
    '&:hover fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)'
    }
  }
});

export const CopyUrlButton = styled(Button)({
  width: '204px',
  height: '42px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  boxSizing: 'border-box',
  borderRadius: '10px',
  textTransform: 'none',
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '15px',
  lineHeight: '26px',
  color: '#3F51B5',
  '&:hover': {
    background: 'white'
  },
  '&.Mui-disabled': {
    color: '#3F51B5',
    opacity: 0.5
  }
});
